let names = {
	4: 'Bronze',
	8: 'Silver',
	12: 'Gold',
	16: 'Diamond',
};

let awards = {};

awards.getName = (aw) => {
	if (!aw) {
		return null;
	}

	return names[parseFloat(aw)];
};

awards.getColourOfAward = (aw) => {
	let c = '';

	switch (parseFloat(aw)) {
		case 4:
			c = '#CD7F32';

			break;
		case 8:
			c = '#C0C0C0';

			break;
		case 12:
			c = '#FFD700';

			break;
		case 16:
			c = '#000000';

			break;
	}

	return c;
};

export default awards;
